<template>
  <article :class="['checkout-ticket-card', { 'is-selected': quantity > 0 }]">
    <div :class="['checkout-ticket-card__media', { 'has-image': Boolean(ticket.generic_image) }]">
      <img v-if="ticket.generic_image" :src="ticket.generic_image" class="checkout-ticket-card__image" alt="">
      <div v-else class="checkout-ticket-card__placeholder"><i class="fas fa-ticket-alt" aria-hidden="true"></i></div>
    </div>
    <div class="checkout-ticket-card__body">
      <div class="checkout-ticket-card__top">
        <div>
          <span v-if="quantity > 0" class="checkout-ticket-card__selected">Seleccionado x{{ quantity }}</span>
          <h3 class="checkout-ticket-card__title">{{ ticket.name }}</h3>
          <p v-if="ticket.description" class="checkout-ticket-card__description">{{ ticket.description }}</p>
        </div>
        <div class="checkout-ticket-card__price">
          <span>{{ ticket.is_courtesy ? 'Cortesía' : money(unitAmount) }}</span>
          <small v-if="taxText">{{ taxText }}</small>
        </div>
      </div>
      <div class="checkout-ticket-card__bottom">
        <div v-if="availability === 1 || quantity > 0" class="quantity-toggle checkout-ticket-card__quantity">
          <button type="button" :disabled="quantity <= 0" :aria-label="`Restar ${ticket.name}`" @click="$emit('decrement')">&minus;</button>
          <input type="text" :value="quantity" :aria-label="`Cantidad de ${ticket.name}`" readonly>
          <button type="button" :disabled="availability !== 1 || quantity >= maxQuantity" :aria-label="`Sumar ${ticket.name}`" @click="$emit('increment')">&plus;</button>
        </div>
        <div v-if="availability === 2" class="checkout-step__status--soon">Próximo precio</div>
        <div v-if="availability === 0" class="checkout-step__status--soldout">Sold out</div>
        <div v-if="lowAvailability > 0 && availability === 1" class="checkout-ticket-card__availability checkout-ticket-card__availability--low">Últimos {{ lowAvailability }}</div>
        <div v-if="quantity > 0" class="checkout-ticket-card__total">{{ unitAmount === 0 ? 'Sin costo' : `Total ${money(unitAmount * quantity)}` }}</div>
      </div>
    </div>
  </article>
</template>

<script>
import { formatCurrencyAmount, normalizeCurrencyCode } from '../../common/currency.js'

export default {
  name: 'CheckoutTicketCard',
  props: {
    ticket: { type: Object, required: true },
    quantity: { type: Number, default: 0 },
    unitAmount: { type: Number, required: true },
    currency: { type: String, default: 'USD' },
    taxText: { type: String, default: '' },
    availability: { type: Number, default: 1 },
    maxQuantity: { type: Number, default: Infinity },
    lowAvailability: { type: Number, default: 0 },
  },
  emits: ['increment', 'decrement'],
  methods: {
    money(value) { return formatCurrencyAmount(value, normalizeCurrencyCode(this.currency)) },
  },
}
</script>

<style scoped>
.checkout-ticket-card__quantity button:active:not(:disabled) { transform: scale(0.9); }
.checkout-ticket-card__quantity button:disabled { opacity: 0.4; cursor: not-allowed; }
</style>
